import { configureStore } from '@reduxjs/toolkit'
import { authApi } from '../redux/services/authApi'
import authReducer from '../redux/features/auth/authSlice'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import toggleThemeReducer from '../redux/features/theme/themeSlice'
import settingReducer from '../redux/features/settings/settingSlice'
import drawerReducer from '../redux/features/drawerNavbar/drawerNavbarSlice'
import licenseReducer from '../redux/features/licenses/licenseSlice'
import selectedFleetFilterReducer from '~/redux/features/fleetFilter/fleeFilterSlice'
import pageSettingReducer from '~/redux/features/pageSize/pageSettingSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    theme: toggleThemeReducer,
    fleetFilter: selectedFleetFilterReducer,
    localSetting: settingReducer,
    drawerSetting: drawerReducer,
    managementLicence: licenseReducer,
    pageSetting: pageSettingReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(authApi.middleware)
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
setupListeners(store.dispatch)
